import React from 'react';
import { Phone, Video, PhoneOff } from 'lucide-react';
import { useGroupCall } from '../../context/GroupCallContext';

export const IncomingGroupCallModal: React.FC = () => {
  const { incomingGroupCall, acceptIncomingGroupCall, declineGroupCall } = useGroupCall();

  if (!incomingGroupCall) return null;

  const isVideo = incomingGroupCall.callType === 'VIDEO';

  return (
    <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-md flex items-center justify-center p-4 select-none animate-in fade-in duration-200">
      <div className="bg-card border border-border rounded-2xl p-6 max-w-sm w-full shadow-2xl text-center space-y-6">
        {/* Animated Icon Header */}
        <div className="relative w-20 h-20 mx-auto flex items-center justify-center">
          <div className="absolute inset-0 rounded-full bg-primary/20 animate-ping opacity-75" />
          <div className="relative w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg">
            {isVideo ? <Video className="h-8 w-8" /> : <Phone className="h-8 w-8" />}
          </div>
        </div>

        {/* Text Details */}
        <div className="space-y-1">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary">
            Incoming Channel Call
          </span>
          <h3 className="font-bold text-xl text-foreground">
            #{incomingGroupCall.channelName || 'general'}
          </h3>
          <p className="text-xs text-muted-foreground">
            Started by <span className="font-medium text-foreground">{incomingGroupCall.callerName || 'Team Member'}</span>
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-center gap-4 pt-2">
          {/* Decline */}
          <button
            onClick={declineGroupCall}
            className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white font-semibold text-xs transition border border-red-500/20 shadow-sm"
          >
            <PhoneOff className="h-4 w-4" />
            <span>Decline</span>
          </button>

          {/* Accept / Join */}
          <button
            onClick={acceptIncomingGroupCall}
            className="flex-1 flex items-center justify-center gap-2 py-3 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-xs transition shadow-md"
          >
            {isVideo ? <Video className="h-4 w-4" /> : <Phone className="h-4 w-4" />}
            <span>Join Call</span>
          </button>
        </div>
      </div>
    </div>
  );
};
